// 封装请求
import axios from 'axios'
import utils from '@/utils/utils.js'

// 请求
const http = axios.create({
    baseURL: `${utils.is_https() ? 'https' : 'http'}://` + process.env.VUE_APP_BASE_URL,
    
})

// 请求拦截
http.interceptors.request.use((config) => {
    // Toast.loading({
    //     message: 'loading...',
    //     forbidClick: true,
    //     duration:0
    // });
    return config
}, (err) => {
    console.log(err);
    
})

// 响应拦截
http.interceptors.response.use((res) => {
    // 定义code/根据状态码全局处理
    // Toast.loading({
    //     duration:1
    //   })
      return res
},
(err) => {
    console.log(err);
})

export default http;